/**
 * Convert a camelCase variable name to a label
 * "facilityName" to "Facility Name"
 */
export function toLabel(name: string): string {
    return name
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (c) => c.toUpperCase())
        .trim();
}
